import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reset-password-success',
  templateUrl: './reset-password-success.component.html',
  styleUrls: ['./reset-password-success.component.scss'],
})
export class ResetPasswordSuccessComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
